export default {
  getCleanedTagType (type) {
    const cleanedMap = {
      'investor_target_area': 'FOCUS',
      'investor_tag': 'TYPE',
      'investor_target_size': 'TARGET SIZE'
    }
    if (type in cleanedMap) {
      return cleanedMap[type]
    }
    return type
  }
}



// WEBPACK FOOTER //
// ./src/components/medicalAlleyStarts/TagMethods.js